import { render, staticRenderFns } from "./EmptyLink.vue?vue&type=template&id=03901872"
import script from "./EmptyLink.vue?vue&type=script&lang=js"
export * from "./EmptyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports